const blockedReasons = {
    OTHER: 'Other',
    TIMELY_FILING: 'Timely Filing',
    };
export default Object.freeze(blockedReasons);
